(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FreshdeskCreateFinanceTicket',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.modal').on('change', '.issue-choices', function _toggleSelect(e) {
			var section = $(this).val();

			$('.modal').find('.sections').addClass('hidden');
			$('.modal').find('.allianz_sections').addClass('hidden');
			$('.modal').find('.vendor_coop_sections').addClass('hidden');

			switch (section) {
				case 'royalty_waiver':
					$('.modal').find('.royalty_waiver').removeClass('hidden');
					break;
				case 'banking_invoices':
					$('.modal').find('.banking_invoices').removeClass('hidden');
					break;
				case 'entering_reservation':
					$('.modal').find('.entering_reservation').removeClass('hidden');
					break;
				case 'vendor_contact':
					$('.modal').find('.vendor_contact').removeClass('hidden');
					break;
				case 'login_registration':
					$('.modal').find('.login_registration').removeClass('hidden');
					break;
				case 'allianz_claims':
					$('.modal').find('.allianz_claims').removeClass('hidden');
					$('.modal').find('.allianz_sections').removeClass('hidden');
					break;
				case 'vendor_coop':
					$('.modal').find('.vendor_coop_sections').removeClass('hidden');
					break;
				case 'missing_commission':
				default:
					$('.modal').find('.missing_commission').removeClass('hidden');
					break;
			}
		});

		$('.modal').on('click', '.email-care-team', function _triggerCareTeam(e) {
			e.preventDefault();

			$('#modalWindow').modal('hide');

			setTimeout(function _openCareTeamWindow() {
				$('.submit-ticket').trigger('click');
			}, 500);
		});

		Adzuki.Typeahead(
			'#freshdeskcreatefinanceticket-reservation',
			'/Reservations/searchQuickActions',
			function select(item, $self, typeahead) {
				selectItem(item, typeahead);
			},
			function template(item) {
				var html = item.dynamic.extra + ' - ' + item.dynamic.identifier;

				return html;
			}
		);

		$('.modal').on('click', '.reset-reservation-link', function _resetReservation(e) {
			e.preventDefault();

			$('#freshdeskcreatefinanceticket-reservation').val('');
			$('#freshdeskcreatefinanceticket-reservation_id').val('');
			$('#freshdeskcreatefinanceticket-reservation_number').val('');
			$('#freshdeskcreatefinanceticket-vendor_id').val('');
			$('#freshdeskcreatefinanceticket-reservation').removeClass('disabled');
			$('#freshdeskcreatefinanceticket-reservation').prop('disabled', false);

			$('#freshdeskcreatefinanceticket-group_number').val('');
			$('#freshdeskcreatefinanceticket-vendor').val('');

			$('.contacted-supplier').removeClass('hidden');
			$('.reset-reservation').addClass('hidden');
		});

		$('.modal').on('click', '.group-radio', function _groupRadio(e) {
			var choice       = $(this).children().val(),
			    cruise_lines = (Adzuki.dev === true ? [35, 12] : [2, 3]), // this swaps the vendor ids from dev & prod - ONLY CEL and RCI
			    vendor_id    = $('#freshdeskcreatefinanceticket-vendor_id').val();

			if (vendor_id !== '' && choice === 'yes' && cruise_lines.indexOf(parseInt(vendor_id)) !== -1) {
				$('.contacted-supplier').addClass('hidden');
			} else {
				$('.contacted-supplier').removeClass('hidden');
			}
		});

		// NATHALIA SAID THEY CAN CONTACT THE SUPPLIER REGARDLESS OF IT BEING A SIGNATURE GROUP - 3/18/24
		// $('.modal').on('click', '.signature-radio', function _signatureRadio(e) {
		// 	var choice = $(this).children().val();

		// 	if (choice === 'yes') {
		// 		$('.contacted-supplier').addClass('hidden');
		// 	} else {
		// 		$('.contacted-supplier').removeClass('hidden');
		// 	}
		// });

		$('.modal').on('click', '.allianz-radio', function _allianzRadio(e) {
			var choice = $(this).children().val();

			if (choice === 'yes') {
				$('.claim-choice').removeClass('hidden');
			} else {
				$('.claim-choice').addClass('hidden');

				$('#freshdeskcreatefinanceticket-claim_approved-1').trigger('click');
			}
		});

		$('.modal').on('click', '.claim-radio', function _allianzFields(e) {
			var choice = $(this).children().val();

			if (choice === 'yes') {
				$('.claim-items').removeClass('hidden');
			} else {
				$('.claim-items').addClass('hidden');
			}
		});
	};

	form.success = function success(response)
	{
		if (!Adzuki.Form.hasError(response)) {
			Adzuki.StatusMessage('Success', 'The ticket has been created.');

			$('.modal').modal('hide');
		}

		return false;
	};

	form.error = function error()
	{
		Adzuki.StatusMessage('Error', 'Error creating ticket');
		return false;
	};

	function selectItem(item, typeahead)
	{
		typeahead.setHiddenValue(item.reservation_component_passenger_meta_data.reservation_id);

		$('#freshdeskcreatefinanceticket-reservation').val(item.reservation_component_passenger_meta_data.confirmation_number);
		$('#freshdeskcreatefinanceticket-reservation_number').val(item.reservation_component_passenger_meta_data.confirmation_number);
		$('#freshdeskcreatefinanceticket-reservation_id').val(item.reservation_component_passenger_meta_data.reservation_id);
		$('#freshdeskcreatefinanceticket-vendor_id').val(item.vendors.vendor_id); 
		$('#freshdeskcreatefinanceticket-reservation').addClass('disabled');
		$('#freshdeskcreatefinanceticket-reservation').prop('disabled', true);

		if (item.reservation_component_passenger_meta_data.group_number !== null) {
			$('#freshdeskcreatefinanceticket-group_number').val(item.reservation_component_passenger_meta_data.group_number);
		}

		if (item.vendors.vendor !== null) {
			$('#freshdeskcreatefinanceticket-vendor').val(item.vendors.vendor);
		}

		if (item.vendors.vendor_id !== null) {
			hideUnhideVendorContact(item.vendors.vendor_id);
		}

		$('.reset-reservation').removeClass('hidden');
	}

	function hideUnhideVendorContact(vendor_id)
	{
		var vendor_ids = (Adzuki.dev === true ? [1053, 162, 784, 5250, 195, 253] : [4983, 5099, 4434, 5250, 5127, 5189]), // this swaps the vendor ids from dev & prod
			$contacted = $('.contacted-supplier');

		if (vendor_ids.indexOf(parseInt(vendor_id)) === -1) {
			$contacted.removeClass('hidden');
		} else {
			$contacted.addClass('hidden');
		}
	}

}(jQuery, window.Adzuki || {}));
